var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasketPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.179,
    height: 18.721,
    viewBox: "0 0 19.179 18.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(-0.025 -0.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M.436,11.888v-.449a.374.374,0,0,0,.03-.066A1.442,1.442,0,0,1,1.906,10.2c.243-.007.487-.009.73,0a.327.327,0,0,0,.3-.142q2.095-2.6,4.2-5.19a2.708,2.708,0,0,1,.366-.4.754.754,0,0,1,.859-.1A.772.772,0,0,1,8.8,5.1a.973.973,0,0,1-.29.649Q6.768,7.879,5.027,10.017c-.033.041-.06.086-.1.135h9.962l-1.725-2.1q-.955-1.163-1.91-2.327a.876.876,0,0,1-.095-1.087.753.753,0,0,1,.908-.288,1.455,1.455,0,0,1,.514.41Q14.724,7.37,16.843,10a.414.414,0,0,0,.377.175c.311-.013.624-.008.936,0a1.5,1.5,0,0,1,.982.4,1.622,1.622,0,0,1,.478.906v.374a.275.275,0,0,0-.032.064q-.9,4.55-1.806,9.1a2.5,2.5,0,0,1-.589,1.327A2.215,2.215,0,0,1,15.5,23q-5.206-.009-10.413,0c-.237,0-.475.006-.712,0a2.076,2.076,0,0,1-2.061-1.744q-.8-3.991-1.586-7.983c-.092-.462-.2-.923-.293-1.384",
    transform: "translate(-0.411 -4.038)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M127.273,206.545c.542,0,1.084,0,1.625,0a.834.834,0,0,1,.823.635.8.8,0,0,1-.434.905,1.068,1.068,0,0,1-.431.095c-1.059.008-2.117.007-3.176,0a.822.822,0,1,1,0-1.639c.529,0,1.059,0,1.588,0",
    transform: "translate(-117.656 -194.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M155.262,180.173c0,.554.006,1.109,0,1.663a.818.818,0,0,1-.7.8.81.81,0,0,1-.89-.554,1.132,1.132,0,0,1-.049-.33q-.005-1.579,0-3.158a.839.839,0,0,1,.575-.85.764.764,0,0,1,.891.3,1.136,1.136,0,0,1,.166.539c.022.529.008,1.059.008,1.588Z",
    transform: "translate(-144.83 -167.537)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketPlus);
export default __webpack_public_path__ + "static/media/basket-plus.ced53acfaf70b47770a922958064bbda.svg";
export { ForwardRef as ReactComponent };